import { render, staticRenderFns } from "./PluginSetup.vue?vue&type=template&id=01681eb3&scoped=true&"
import script from "./PluginSetup.vue?vue&type=script&lang=js&"
export * from "./PluginSetup.vue?vue&type=script&lang=js&"
import style0 from "./PluginSetup.vue?vue&type=style&index=0&id=01681eb3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01681eb3",
  null
  
)

export default component.exports